import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape } from '../../../helpers/custom-prop-types';
const TagList = (props) => {
    const { tags } = props;
    if (!tags.length) {
        return null;
    }
    return (_jsx("ul", Object.assign({ className: 'ui-tags' }, { children: tags.map((v) => (_jsx("li", Object.assign({ className: 'tag-column' }, { children: _jsx("span", Object.assign({ className: 'tag-text' }, { children: v.name })) }), v.id))) })));
};
TagList.propTypes = {
    tags: propArrayShape().isRequired,
};
export default TagList;
